'use client';

import { useCookieConsent } from '../../../contexts/CookieConsentContext';
import styles from '../../../styles/components/cookies/cookieConsent.module.scss';

/**
 * Банер при първо посещение: „Приеми всички", „Само необходими", „Настройки".
 */
export default function CookieBanner() {
  const { acceptAll, rejectAll, openSettings } = useCookieConsent();

  return (
    <div
      className={styles.banner}
      role="dialog"
      aria-live="polite"
      aria-label="Съгласие за бисквитки"
    >
      <div className={styles.bannerInner}>
        <p className={styles.bannerText}>
          Използваме бисквитки за анализ и маркетинг, за да подобрим сайта и рекламите си. Можеш
          да приемеш всички, да откажеш незадължителните или да управляваш настройките си.
          {' '}
          <a href="/pages/privacy" className={styles.link}>
            Политика за поверителност
          </a>
        </p>

        <div className={styles.bannerActions}>
          <button type="button" className={styles.btnGhost} onClick={openSettings}>
            Настройки
          </button>
          <button type="button" className={styles.btnSecondary} onClick={rejectAll}>
            Само необходими
          </button>
          <button type="button" className={styles.btnPrimary} onClick={acceptAll}>
            Приеми всички
          </button>
        </div>
      </div>
    </div>
  );
}
